import { apiNoAuth } from "./conection.js";

export const departmentsServices = {
  // Departamentos
  getDepartments: async () => {
    try {
      const response = await apiNoAuth.get("/departments/");
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar departamentos:", error);
      throw error;
    }
  },
  getDepartmentById: async (id) => {
    try {
      const response = await apiNoAuth.get(`/departments/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar departamento:", error);
      throw error;
    }
  },
};
